<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"><a id="page_iv"></a>Copyright © 2015 Fordham University Press</p>
<p class="copy">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.</p>
<p class="copy">This book was originally published in French as Jean-Luc Nancy, <em>L’Équivalence des catastrophes (Après Fukushima)</em> © Éditions Galilée, 2012.</p>
<p class="copy">Fordham University Press has no responsibility for the persistence or accuracy of URLs for external or third-party Internet websites referred to in this publication and does not guarantee that any content on such websites is, or will remain, accurate or appropriate.</p>
<p class="copy">Fordham University Press also publishes its books in a variety of electronic formats. Some content that appears in print may not be available in electronic books.</p>
<p class="copy">Library of Congress Cataloging-in-Publication Data is available from the publisher.</p>
<p class="copy">Nancy, Jean-Luc.<br/>
  [Équivalence des catastrophes (après Fukushima)]<br/>
  After Fukushima : the equivalence of catastrophes / Jean-Luc Nancy ; translated by Charlotte Mandell.<br/>
  pages cm<br/>
  Translation of: Équivalence des catastrophes (après Fukushima)<br/>
  Includes bibliographical references.<br/>
  ISBN 978-0-8232-6338-7 (hardback) — ISBN 978-0-8232-6339-4 (paper)<br/>
  1. Disasters—Philosophy. 2. Technology—Philosophy. 3. Fukushima Nuclear Disaster, Japan, 2011. I. Title.<br/>
  B2430.N363E6413 2015<br/>
  363.3401—dc23<br/>
  2014027974</p>
<p class="copy">17 16 15 5 4 3 2 1</p>
<p class="copy">First edition</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0556c2c6